module.exports = __webpack_public_path__ + "static/media/campusImgC.369ddbc0.png";